import { IconButton } from '@apia/components';
import { getLabel, useImperativeComponentEvents } from '@apia/util';
import { useCallback, useState } from 'react';
import { usePanelConfig } from '../../../config/usePanelConfig';
import { usePanelActions } from '../../../actions';
import { panelButtonsActions } from './PanelButtons';
import { usePanelIdentity } from '../../../common';

export const SettingsButton = (props: { title: string }) => {
  const { panelId } = usePanelIdentity();
  const configure = usePanelConfig();

  const [isDisabled, setIsDisabled] = useState(false);
  useImperativeComponentEvents({
    disable(newDisabledValue: boolean) {
      setIsDisabled(newDisabledValue);
    },
  });

  usePanelActions({
    refresh() {
      panelButtonsActions(panelId, 'disable', false);
    },
  });

  const openSettings = useCallback(() => {
    try {
      configure();
    } catch (e) {}
  }, [configure]);

  return (
    <IconButton
      icon="Settings"
      size="Md"
      variant="buttons.icon-outline"
      className="panel__iconButton"
      onClick={openSettings}
      title={getLabel('lblOpenPnlConf', { text: { TOK1: props.title } }).text}
      disabled={isDisabled}
    />
  );
};
